import { Currency, isCurrency } from "@redotech/money/currencies";
import { RateSource } from "@redotech/money/rate-source";
import { RateRef } from "./rate";

const PREFIX = "fx-rate";

/** Canonical id used as both pub/sub topic and demand-set member, so they share a key. */
export function fxRateTopicId(
  source: RateSource,
  base: Currency,
  quote: Currency,
): string {
  return `${PREFIX}:${source}:${base}:${quote}`;
}

const RATE_SOURCES = new Set<string>(Object.values(RateSource));

/** `undefined` for a malformed id, so a stale/garbage demand-set member is skipped. */
export function parseFxRateTopicId(id: string): RateRef | undefined {
  const parts = id.split(":");
  if (parts.length !== 4 || parts[0] !== PREFIX) {
    return undefined;
  }
  const [, source, base, quote] = parts;
  if (
    source === undefined ||
    base === undefined ||
    quote === undefined ||
    !RATE_SOURCES.has(source) ||
    !isCurrency(base) ||
    !isCurrency(quote)
  ) {
    return undefined;
  }
  // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
  return { source: source as RateSource, base, quote };
}
